import { startsWith } from 'lodash';
import { EntityTypesEnum } from '../../app.enum';
import {
  entityKeys,
  entityModelFactory,
  generateContent,
} from '../entity-data/entity.model';
import { ItemUnitTypesEnum } from './item-data.data';

export const CONTENT_SCHEMA = Object.freeze({
  CODE: '',
  NAME: '',
  DETAILS: '',
  RATE: 0,
  COST: 0,
  TAXABLE: true,
  UNIT_TYPE: ItemUnitTypesEnum.parts,
  CURRENCY_CODE: '',
  LOCALE: '',
});
const KEYS = entityKeys({}, CONTENT_SCHEMA);
export const CONTENT_KEYS = generateContent(CONTENT_SCHEMA).KEYS;

export class Item extends entityModelFactory({}, null, CONTENT_SCHEMA, null) {
  static ENTITY_TYPE: EntityTypesEnum = EntityTypesEnum.product;
  static KEYS: any = KEYS;
  static CONTENT_KEYS: any = CONTENT_KEYS;

  get ENTITY_TYPE(): string {
    return Item.ENTITY_TYPE;
  }

  get name(): string {
    return this.getFieldInContent(CONTENT_KEYS.NAME);
  }

  get details(): string {
    return this.getFieldInContent(CONTENT_KEYS.DETAILS);
  }

  get rate(): number {
    return this.getFieldInContent(CONTENT_KEYS.RATE);
  }

  get unitType(): ItemUnitTypesEnum {
    return this.getFieldInContent(CONTENT_KEYS.UNIT_TYPE);
  }

  get cost(): number {
    return this.getFieldInContent(CONTENT_KEYS.COST);
  }

  get code(): string {
    return this.getFieldInContent(CONTENT_KEYS.CODE);
  }

  get taxable(): boolean {
    return this.getFieldInContent(CONTENT_KEYS.TAXABLE);
  }

  get currencyCode(): string {
    return this.getFieldInContent(CONTENT_KEYS.CURRENCY_CODE);
  }

  get locale(): string {
    return this.getFieldInContent(CONTENT_KEYS.LOCALE);
  }

  isPart(): boolean {
    return startsWith(this.unitType, 'parts');
  }

  isLabor(): boolean {
    return startsWith(this.unitType, 'labor');
  }
}
